import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import { verifyEmail } from "../../helpers/fakebackend_helper";
import AhAuthShell from "./AhAuthShell";

const VerifyEmail = () => {
    document.title = "Verify email | ApiHub";
    const { code } = useParams();
    const [status, setStatus] = useState("loading"); // loading | success | error
    const [message, setMessage] = useState("");

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            if (!code) {
                setStatus("error");
                setMessage("Verification code is missing.");
                return;
            }
            try {
                const res = await verifyEmail(code);
                if (cancelled) return;
                if (res && res.success) {
                    setStatus("success");
                    setMessage(res.message || "Email verified successfully.");
                } else {
                    setStatus("error");
                    setMessage((res && res.message) || "Could not verify email.");
                }
            } catch (err) {
                if (cancelled) return;
                setStatus("error");
                setMessage(typeof err === "string" ? err : (err && err.message) || "Network error.");
            }
        };
        run();
        return () => { cancelled = true; };
    }, [code]);

    const titleMap = {
        loading: "Verifying your email",
        success: "Email verified",
        error: "Verification failed",
    };
    const subMap = {
        loading: "This will only take a moment…",
        success: "Your email is confirmed. You can sign in now.",
        error: "Something went wrong. The link may have expired.",
    };

    return (
        <AhAuthShell
            eyebrow="EMAIL VERIFICATION"
            title={titleMap[status]}
            subtitle={subMap[status]}
            footer={
                status === "success"
                    ? <Link to="/login">Continue to sign in →</Link>
                    : <Link to="/login">Back to sign in</Link>
            }
        >
            {status === "loading" && (
                <div style={{ textAlign: "center", padding: "16px 0 8px" }}>
                    <Spinner color="primary" />
                </div>
            )}

            {status === "success" && (
                <div className="ah-notice" role="status">
                    <div className="ah-notice-icon"><i className="ri-checkbox-circle-line"></i></div>
                    <div className="ah-notice-body">
                        <strong>You're all set.</strong>
                        <div style={{ marginTop: 4, color: "oklch(0.82 0.06 65)" }}>{message}</div>
                    </div>
                </div>
            )}

            {status === "error" && (
                <div className="alert alert-danger" role="alert" style={{ marginBottom: 0 }}>
                    {message}
                </div>
            )}
        </AhAuthShell>
    );
};

export default VerifyEmail;
